export default `<img src="/banners/pr_advertising_ads_banner.gif" alt="" onerror="this.remove()" />`;
